<app-loader *ngIf="isDisabled"></app-loader>
<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="stepper-nav" [destroyOnHide]="false">
    <li [ngbNavItem]="1">
        <button ngbNavLink><i class="bi bi-diagram-2-fill"></i></button>
        <span class="stepper-text">Site</span>
        <ng-template ngbNavContent> <br>
            <div class="card">
                <div class="card-header">
                    Site Details
                </div>
                <div class="card-body">
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Industry Segment <span class="text-danger"
                                    *ngIf="this.common.CompanyParameterValue.CCCode">*</span></label>
                            <ng-select name="industrysegment" [items]="IndustrySeg" bindLabel="IndustrySegmentName"
                                bindValue="IndustrySegmentID" [(ngModel)]="IndustryId"
                                placeholder="Select Industry Segment"
                                [disabled]="Sitedatafrmview.EditSData && this.common.CompanyParameterValue.CCCode">
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Service Type <span class="text-danger"
                                    *ngIf="this.common.CompanyParameterValue.CCCode">*</span></label>
                            <ng-select name="servicetype" [items]="ServiceType" bindLabel="ServiceTypeName"
                                bindValue="ServiceTypeID" [(ngModel)]="ServiceId" placeholder="Select Service Type"
                                [disabled]="Sitedatafrmview.EditSData && this.common.CompanyParameterValue.CCCode">
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Region <span class="text-danger"
                                    *ngIf="this.common.CompanyParameterValue.CCCode">*</span></label>
                            <ng-select name="Region" [items]="RegionMaster" bindLabel="RegionName"
                                bindValue="RegionMasterID" [(ngModel)]="RegionId" placeholder="Select Region"
                                [disabled]="Sitedatafrmview.EditSData && this.common.CompanyParameterValue.CCCode"
                                (change)="ComboLoad2('Branch');onSelectChange('Region')">
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Branch <span class="text-danger">*</span></label>
                            <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName"
                                bindValue="BranchMasterID" [(ngModel)]="BranchId" placeholder="Select Branch"
                                [disabled]="Sitedatafrmview.EditSData" (change)="onSelectChange('Branch')">
                            </ng-select>
                        </div>
                    </div>

                    <div class="row m-1">

                        <div class="col-md-4 px-1">
                            <label class="Label">Channel <span
                                    *ngIf="this.common.CompanyParameterValue.IsESSSiteMasterChannelCode"
                                    class="mandatory-field">*</span></label>
                            <ng-select [items]="Channels" bindLabel="ChannelName" bindValue="ChannelMasterID"
                                placeholder="Select Channel" [(ngModel)]="SiteChannelId" name="channel"
                                [required]="this.common.CompanyParameterValue.IsESSSiteMasterChannelCode">
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select channel!
                            </div>
                        </div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Old ERP Code <small class="text-muted">(e.g. Oracle)</small><span
                                    *ngIf="this.common.CompanyParameterValue.IsESSSiteMasterOracleCode"
                                    class="mandatory-field">*</span></label>
                            <input name="oraclecode" [maxlength]="6" [minlength]="6" type="text"
                                [(ngModel)]="SiteOracleCode" class="form-control" placeholder="Enter Oracle Code"
                                (keypress)="onKeyPressNumbersOnly($event)"
                                [required]="this.common.CompanyParameterValue.IsESSSiteMasterOracleCode" />
                            <div class="invalid-feedback">
                                Please enter old erp code!
                            </div>
                        </div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Alternate Code</label>
                            <input name="alternatecode" [maxlength]="6" [minlength]="6" type="text"
                                [(ngModel)]="SiteAlternateCode" class="form-control" placeholder="Enter Alternate Code"
                                (keypress)="onKeyPressNumbersOnly($event)" />
                        </div>

                    </div>

                    <div class="row m-1">
                        <div class="col-md-6 px-1">
                            <label class="Label">Group</label>
                            <ng-select [items]="Groups" bindLabel="SiteGroupName" bindValue="SiteGroupMasterID"
                                placeholder="Select group" [(ngModel)]="SiteGroupMasterID" name="sitegroup"
                                (change)="loadSubgroup()">
                            </ng-select>
                        </div>

                        <div class="col-md-6 px-1">
                            <label class="Label">Sub Group</label>
                            <ng-select [items]="FilteredSubGroups" bindLabel="SiteSubGroupName"
                                bindValue="SiteSubGroupMasterID" placeholder="Select subgroup"
                                [(ngModel)]="SiteSubGroupMasterID" name="sitesubgroup">
                            </ng-select>
                        </div>
                    </div>

                    <div class="row m-1">
                        <div class="col-md-9 px-1">
                            <label class="Label">Customer Group<span class="text-danger">*</span></label>
                            <ng-select name="cutomergroup" [items]="CustomerGroup" bindLabel="ClientGroupName"
                                bindValue="ClientGroupMasterID" [(ngModel)]="CustGrpId"
                                placeholder="Select Customer Group" (change)="onSelectChange('Customergroup')"
                                [disabled]="Sitedatafrmview.EditSData">
                            </ng-select>
                        </div>

                        <div class="col-md-9 px-1">
                            <label class="Label">Billing Customer</label>
                            <ng-select name="billingcustomer" [items]="BillingCustomer" bindLabel="ClientGroupName"
                                bindValue="ClientGroupID" [(ngModel)]="BillCustId"
                                placeholder="Select Billing Customer">
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Site Code</label>
                            <input name="sitecode" type="text" [disabled]="true" [(ngModel)]="SiteCode"
                                class="form-control" [disabled]="true" placeholder="Site Code" />
                        </div>
                        <div class="col-md-6 px-1">
                            <label class="Label">Site Name<span class="text-danger">*</span></label>
                            <input name="sitename" type="text" [(ngModel)]="SiteName" class="form-control"
                                placeholder="Enter Site Name" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Financial Branch<span class="text-danger">*</span></label>
                            <ng-select name="financialbranch" [items]="FinancialBranch" bindLabel="DivisionName"
                                bindValue="DivisionMasterId" [(ngModel)]="FinBranchid"
                                placeholder="Select Financial Branch">
                            </ng-select>
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">Rate Contract Group<span class="text-danger">*</span></label>
                            <ng-select name="ratecontract" [items]="Group" bindLabel="GroupName"
                                bindValue="GroupMasterID" [(ngModel)]="GroupId"
                                placeholder="Select Rate Contract Group">
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-9 px-1">
                            <label class="Label">Address Line 1<span class="text-danger">*</span></label>
                            <div class="md-form">
                                <textarea type="text" id="address1" [(ngModel)]="Address1" name="address1"
                                    class="md-textarea md-textarea-auto form-control" placeholder="Enter Address Line 1"
                                    style="resize: none; height: 22px;" mdbInput></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-9 px-1">
                            <label class="Label">Address Line 2</label>
                            <div class="md-form">
                                <textarea type="text" id="address2" name="address2" [(ngModel)]="Address2"
                                    class="md-textarea md-textarea-auto form-control" placeholder="Enter Address Line 2"
                                    style="resize: none; height: 22px;" mdbInput></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">City</label>
                            <input name="city" type="text" [(ngModel)]="City" class="form-control"
                                placeholder="Enter City" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Pin Code</label>
                            <input name="pincode" type="text" [(ngModel)]="Pincode" class="form-control" maxlength="7"
                                (input)="filterInput($event)" placeholder="Enter Pin Code" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Tel. No.</label>
                            <input name="telno" type="text" [(ngModel)]="Telephone" class="form-control" maxlength="20"
                                (input)="filterInput($event)" placeholder="Enter Tel. No." />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">State</label>
                            <ng-select name="state" [items]="State" bindLabel="StateName" bindValue="StateMasterID"
                                [(ngModel)]="Stateid" placeholder="Select State"
                                (change)="ComboLoad('District');onSelectChange('State')">
                            </ng-select>
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">District</label>
                            <ng-select name="district" [items]="District" bindLabel="DistrictName"
                                bindValue="DistrictMasterID" [(ngModel)]="DistrictId" placeholder="Select District"
                                (change)="ComboLoad('Taluka');onSelectChange('District')">
                            </ng-select>
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Taluka<span class="text-danger">*</span> </label>
                            <ng-select name="taluka" [items]="Taluka" bindLabel="TalukaName" bindValue="TalukaMasterID"
                                [(ngModel)]="TalukaId" placeholder="Select Taluka">
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Contact Person Name <span class="text-danger">*</span></label>
                            <input name="contactpersonname" [(ngModel)]="ContactPersonName" type="text"
                                class="form-control" placeholder="Enter Contact Person Name" />
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">Contact Person Email<span class="text-danger">*</span></label>
                            <input name="contactpersonemail" [(ngModel)]="ContactPersonEmail" type="email"
                                class="form-control" maxlength="100" placeholder="Enter Contact Person Email" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Contact Person No.</label>
                            <input name="contactpersonno" [(ngModel)]="ContactPersonNo" type="text" class="form-control"
                                maxlength="20" (input)="filterInput($event)" placeholder="Enter Contact Person No." />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Compliance/Non-Compliance</label>
                            <ng-select name="compliancenoncompliance" [(ngModel)]="Compliance"
                                placeholder="Select Compliance/Non-Compliance">
                                <ng-option value="Compliance">Compliance</ng-option>
                                <ng-option value="Non-Compliance">Non-Compliance</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Bill Type</label>
                            <select class="form-select" name="billtype" [(ngModel)]="BillTypeValue"
                                (change)="onSelectChange('BillTypeValue')" placeholder="Select Bill Type">
                                <option value="FB">Fixed Billing</option>
                                <option value="MB">Muster Billing</option>
                                <option value="BO">BillOnSalaryCTC</option>
                            </select>
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Bill Duty Division By <span class="text-danger">*</span></label>
                            <input name="billdutydivisionby" [(ngModel)]="BillDutyDivisionBy" style="text-align: right;"
                                type="text" class="form-control" placeholder="Enter Bill Duty Division By" maxlength="6"
                                (keypress)="PreventKey($event)" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Zone Master</label>
                            <ng-select name="zonemaster" [items]="ZoneMaster" bindLabel="ZoneName"
                                bindValue="ZoneMasterID" [(ngModel)]="ZoneId" placeholder="Select Zone">
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1" style="padding-top: 8px;padding-bottom: 8px;">
                        <div class="col-md-2 px-1">
                            <label class="Label">
                                <input type="checkbox" name="pfonbasic" [(ngModel)]="pfonbasicdaot" ngbCheckbox />
                                PF on Basic DA OT
                            </label>
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">
                                <input type="checkbox" name="admin" [(ngModel)]="AdminCharge" ngbCheckbox />
                                Admin
                                Charges
                            </label>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">
                                <input type="checkbox" name="attendence" [(ngModel)]="attendence" ngbCheckbox />
                                Online Attendence Freeze
                            </label>
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">
                                <input type="checkbox" name="active" [(ngModel)]="Isactive" ngbCheckbox />
                                Active
                            </label>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <div class="card">
                                <label class="Label1" style="text-decoration: underline;">Salary
                                    Calculation</label>
                                <div class="btn-group btn-group-toggle" (change)="onSelectChange('SalaryCalculation')"
                                    style="width: 100%;">
                                    <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'D'" name='datewise'
                                            [(ngModel)]="SalaryCalcDate" (keypress)="PreventKey($event)">
                                        DateWise
                                    </label>
                                    <label class="form-check-label link-dark px-1 Label" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'M'" name='datewise'
                                            [(ngModel)]="SalaryCalcDate">
                                        MonthWise
                                    </label>
                                </div>
                                <div class="row m-1">
                                    <div class="col-md-2 px-1">
                                        <label class="Label">From:</label>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <input name="salfrom" style="text-align: right;height: 80%;"
                                            [(ngModel)]="SalaryFrom" [disabled]="SalaryCalcDate === 'M'"
                                            (blur)="onSelectChange('Salary')" maxlength="2" type="text"
                                            class="form-control" (keypress)="PreventKey($event)" />
                                    </div>
                                    <div class="col-md-2 px-1">
                                    </div>
                                    <div class="col-md-1 px-1">
                                        <label class="Label">To:</label>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <input name="salto" style="text-align: right; height: 80%;"
                                            [(ngModel)]="SalaryTo" maxlength="2" [disabled]="SalaryCalcDate" type="text"
                                            class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 px-1">
                            <div class="card">
                                <label class="Label1" style="text-decoration: underline;">Billing
                                    Calculation</label>
                                <div class="btn-group btn-group-toggle" style="width: 100%;"
                                    (change)="onSelectChange('BillingCalculation')">
                                    <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'D'" name='monthwise'
                                            [(ngModel)]="BillingCalcDate" (keypress)="PreventKey($event)">
                                        DateWise
                                    </label>
                                    <label class="form-check-label link-dark px-1 Label" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'M'" name='monthwise'
                                            [(ngModel)]="BillingCalcDate">
                                        MonthWise
                                    </label>
                                </div>
                                <div class="row m-1">
                                    <div class="col-md-2 px-1">
                                        <label class="Label">From:</label>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <input name="billingfrom" style="text-align: right;height: 80%;" type="text"
                                            class="form-control" [(ngModel)]="BillingFrom" maxlength="2"
                                            [disabled]="BillingCalcDate === 'M'" (blur)="onSelectChange('Billing')"
                                            (keypress)="PreventKey($event)" />
                                    </div>
                                    <div class="col-md-2 px-1">
                                    </div>
                                    <div class="col-md-1 px-1">
                                        <label class="Label">To:</label>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <input name="billingto" style="text-align: right; height: 80%;" type="text"
                                            class="form-control" [(ngModel)]="BillingTo" maxlength="2"
                                            [disabled]="BillingCalcDate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 px-1">
                            <div class="card">
                                <label class="Label1" style="text-decoration: underline;">Statutory
                                    Applicable</label>
                                <div class="card-body">
                                    <div>
                                        <label class="Label" style="margin-left: 4%;">
                                            <input type="checkbox" name="pf" [(ngModel)]="PfApplicable" ngbCheckbox />
                                            PF
                                        </label>
                                        <label class="Label" style="margin-left: 4%;">
                                            <input type="checkbox" name="esic" [(ngModel)]="ESICApplicable"
                                                ngbCheckbox /> ESIC
                                        </label>
                                        <label class="Label" style="margin-left: 4%;">
                                            <input type="checkbox" name="pt" [(ngModel)]="PTApplicable" ngbCheckbox />
                                            PT
                                        </label>
                                        <label class="Label" style="margin-left: 4%;">
                                            <input type="checkbox" name="lwf" [(ngModel)]="LWFApplicable" ngbCheckbox />
                                            LWF
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Weekly Off Division By:</label>
                            <input name="billdutydivisionby" [(ngModel)]="WeeklyOffDivisionBy" type="text"
                                class="form-control" style="text-align: right;" (keypress)="PreventKey($event)"
                                placeholder="Enter Weekly Off Division By" maxlength="6" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Site Owner<span class="text-danger">*</span></label>
                            <ng-select (change)="siteOwnerChange()" name="siteowner" [items]="SiteOwner" bindLabel="SiteOwnerName"
                                bindValue="SiteOwnerMasterID" [(ngModel)]="SiteOwnerId" placeholder="Select Site Owner">
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Site Type</label>
                            <ng-select name="sitetype" [items]="SiteType" bindLabel="SiteTypeName"
                                bindValue="SiteTypeMasterID" [(ngModel)]="SiteTypeID" placeholder="Select Site Type">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label">{{BranchName}}</label>
                            </div>
                            <div class="row">
                                <label class="Label">#{{SiteCode}}</label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>
                            <button class="btn btn-sm btn-primary" name="btn1" (click)="goToNextTab('Tab1')">
                                <i class="bi bi-arrow-right" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save & Next':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="2">
        <button ngbNavLink><i class="bi bi-geo-fill"></i></button>
        <span class="stepper-text">Geo Location</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card-header">
                    Geo Location Details
                </div>
                <div class="card-body">
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Latitude</label>
                            <input name="latitude" [(ngModel)]="latitude" type="text" class="form-control"
                                placeholder="Enter Latitude" (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Longitude</label>
                            <input name="longitude" type="text" [(ngModel)]="longitude" class="form-control"
                                placeholder="Enter Longitude" (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Radius (meter)</label>
                            <input name="radius" type="text" [(ngModel)]="Radius" class="form-control"
                                placeholder="Enter Radius" (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>

                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 mt-3">
                            <input class="form-check-input" name="isaltitudeapplicable" id="Active" type="checkbox"
                                [(ngModel)]="IsAltitudeApplicable" value="" />&nbsp;&nbsp;
                            <label class="text-label-dark Label" for="checkbox">
                                Altitude Applicable</label>
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Altitude (feet)</label>
                            <input [disabled]="!IsAltitudeApplicable" name="altitude" type="text" [(ngModel)]="Altitude"
                                class="form-control" placeholder="Enter Altitude"
                                (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Altitude Radius (feet)</label>
                            <input [disabled]="!IsAltitudeApplicable" name="altituderadius" type="text"
                                [(ngModel)]="AltitudeRadius" class="form-control" placeholder="Enter Altitude"
                                (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Accuracy</label>
                            <input name="accuracy" type="text" [(ngModel)]="Accuracy" class="form-control"
                                placeholder="Enter Accuracy" (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Heading</label>
                            <input name="heading" type="text" [(ngModel)]="Heading" class="form-control"
                                placeholder="Enter Heading" (keypress)="ValidateInput($event, 'Latitude')" />
                        </div>
                        <div class="col-md-2 mt-4 px-1">
                            <label class="Label">
                                <input type="checkbox" name="ismocked" [(ngModel)]="IsMocked" ngbCheckbox />
                                IsMocked
                            </label>
                        </div>
                        <div class="col mt-4 px-1">
                            <button class="btn btn-sm btn-primary text-nowrap" name="submit" (click)="openGoogleMaps()">
                                <i class="bi bi-geo-fill" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Locate':'Loading...'}}
                            </button>
                        </div>
                    </div>
                    <div class="row m-1">
                        <!-- <div class="col-md-2 px-1">
                            <label class="Label">
                                <input type="checkbox" name="ismocked" [(ngModel)]="IsMocked" ngbCheckbox />
                                IsMocked
                            </label>
                        </div>
                        <div class="col px-1">
                            <button class="btn btn-sm btn-primary text-nowrap" name="submit" (click)="openGoogleMaps()">
                                <i class="bi bi-geo-fill" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Locate':'Loading...'}}
                            </button>
                        </div> -->
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label">{{BranchName}}</label>
                            </div>
                            <div class="row">
                                <label class="Label">#{{SiteCode}}</label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>
                            <button class="btn btn-sm btn-primary" name="btn2" (click)="goToNextTab('Tab2')">
                                <i class="bi bi-arrow-right" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save & Next':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="3">
        <button ngbNavLink><i class="bi bi-ticket-detailed-fill"></i></button>
        <span class="stepper-text">Addition Details 1</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card-header">
                    Work Order Details
                </div>
                <div class="card-body">
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Agreement Type</label>
                            <ng-select name="agreementype" [(ngModel)]="AgreementType"
                                placeholder="Select Agreement Type">
                                <ng-option value="LOI">LOI</ng-option>
                                <ng-option value="WO">WO</ng-option>
                                <ng-option value="PO">PO</ng-option>
                                <ng-option value="AGREEMENT">AGREEMENT</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">LOI/WO/PO/Agree No.</label>
                            <input name="LOIWOPOagreeno" [(ngModel)]="WorkOrderNumber" type="text" class="form-control"
                                placeholder="Enter LOI/WO/PO/Agree No." />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Client's Site Code</label>
                            <input name="clientsiteCode" [(ngModel)]="ClientSiteCode" type="text" class="form-control"
                                placeholder="Enter Client's Site Code" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">LOI/WO/PO/Agree Dt.</label>
                            <div class="input-group">
                                <input class="form-control" name="workorderdate" name="LOIdate"
                                    placeholder="Ex. DD MM YYYY" [(ngModel)]="WorkOrderDate" ngbDatepicker
                                    #d="ngbDatepicker" [ngModelOptions]="{standalone: true}"
                                    [minDate]="{ year: 1930, month: 1, day: 1 }"
                                    [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                                    type="button" type="button"></button>
                            </div>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Valid Till</label>
                            <div class="input-group">
                                <input class="form-control" name="validtill" placeholder="Ex. DD MM YYYY"
                                    [(ngModel)]="ValidTill" ngbDatepicker #d1="ngbDatepicker"
                                    [minDate]="{ year: 1930, month: 1, day: 1 }"
                                    [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                                    type="button"></button>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Work Order Value</label>
                            <input name="workordervalue" [(ngModel)]="WorkOrderValue" type="text" class="form-control"
                                placeholder="Enter Work Order Value" (keypress)="ValidateInput($event, 'NumandDec')" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Contract Start Date</label>
                            <div class="input-group">
                                <input class="form-control" name="contractstartdate" placeholder="Ex. DD MM YYYY"
                                    [(ngModel)]="ContractStartDate" ngbDatepicker #d2="ngbDatepicker"
                                    [minDate]="{ year: 1930, month: 1, day: 1 }"
                                    [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d2.toggle()"
                                    type="button"></button>
                            </div>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Contract Value(FTM)</label>
                            <input name="contractValue" [(ngModel)]="ContractValue" type="text" class="form-control"
                                placeholder="Enter Contract Value(FTM)"
                                (keypress)="ValidateInput($event, 'NumandDec')" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Annual Value</label>
                            <input name="Annual" type="text" [(ngModel)]="AnnualValue" class="form-control"
                                placeholder="Enter Annual Value" (keypress)="ValidateInput($event, 'NumandDec')" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-7 px-1">
                            <label class="Label">Narration</label>
                            <div class="md-form">
                                <textarea type="text" id="narration" name="narration"
                                    class="md-textarea md-textarea-auto form-control"
                                    style="resize: none; height: 22px;" [(ngModel)]="Narration" mdbInput
                                    placeholder="Enter Narration"></textarea>
                            </div>
                        </div>

                        <div class="col-md-5 px-1">
                            <label class="Label">Agreement Attachment</label>
                            <div class="file-input-container">
                                <input class="form-control form-control-sm" id="formFileSm" type="file"
                                    *ngIf="!SiteAgreementCopyAttachment" (change)="onFileSelected($event)"
                                    accept=".pdf,image/*" />
                                <span *ngIf="SiteAgreementCopyAttachment" class="file-name mt-1">{{
                                    SiteAgreementCopyAttachment
                                    }}</span>
                                <span *ngIf="SiteAgreementCopyAttachment"> <button class="btn btn-sm mt-1" name="view"
                                        type="button" style="color: blue;" (click)="viewFile()"><i
                                            class="bi bi-eye"></i></button></span>
                                <button class="btn btn-sm mt-1" name="delete" type="button"
                                    *ngIf="SiteAgreementCopyAttachment" (click)="removeFile()">
                                    <i class="bi bi-trash text-danger"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">No. of Agreement</label>
                            <input name="noofaggrement" [(ngModel)]="NoOfAgreement" type="text" class="form-control"
                                style="text-align: right;" placeholder="Enter No. of Agreement"
                                (keypress)="PreventKey($event)" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Report Type / Area</label>
                            <ng-select name="reporttype" [items]="ReportTypeMaster" [(ngModel)]="ReportTypeId"
                                bindLabel="ReportTypeName" bindValue="ReportTypeMasterID"
                                placeholder="Select Report Type/Area">
                                <ng-option *ngFor="let segment of ReportTypeMaster"
                                    [value]="segment.ReportTypeMasterID">
                                    {{ segment.ReportTypeName }}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Tender</label>
                            <ng-select name="tender" [(ngModel)]="Tender" placeholder="Select Tender">
                                <ng-option value="Yes">Yes</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Tenure Of Contract</label>
                            <input name="tenureofcontract" [(ngModel)]="TenureofContract" type="text"
                                class="form-control" placeholder="Enter Tenure of Contract"
                                (keypress)="PreventKey($event)" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Min Esclation Clause</label>
                            <input name="minesclationclause" [(ngModel)]="MinimumEscalationClause" type="text"
                                class="form-control" placeholder="Enter Min Esclation Clause"
                                (keypress)="PreventKey($event)" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Billing Name</label>
                            <input name="billingname" [(ngModel)]="BillingName" type="text" class="form-control"
                                placeholder="Enter Billing Name" />
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            Bank Details
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="Label">Bank</label>
                                    <ng-select [items]="Banks" bindLabel="BankName" bindValue="OurCompanyBankMasterID"
                                        placeholder="Select Bank" [(ngModel)]="SiteBankId" name="bank"
                                        (change)="loadbankdetail()">
                                    </ng-select>
                                </div>
                                <div class="col-md-6">
                                    <label class="Label">Bank Name</label>
                                    <input name="bankname" [(ngModel)]="BankName" type="text" class="form-control"
                                        placeholder="Bank Name" [disabled]="true" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="Label">Account No.</label>
                                    <input name="accountno" [(ngModel)]="AccountNumber" type="text" class="form-control"
                                        placeholder="Account Number" [disabled]="true" />
                                </div>

                                <div class="col-md-6">
                                    <label class="Label">IFSC Code</label>
                                    <input name="ifsccode" [(ngModel)]="IFSCcode" type="text" class="form-control"
                                        placeholder="IFSC Code" [disabled]="true" />
                                </div>

                                <div class="col-md-6">
                                    <label class="Label">Branch Name</label>
                                    <input name="bankbranchname" [(ngModel)]="BankBranchName" type="text"
                                        class="form-control" placeholder="Branch Name" [disabled]="true" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2 m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">
                                Bill To/ Ship To Select
                                <input type="checkbox" name="billtooption" [(ngModel)]="BillToOption"
                                    (change)="checkboxChanged($event)" ngbCheckbox />
                            </label>
                        </div>
                    </div>

                    <div class="row m-1">
                        <div class="col-md-2 px-1">
                            <label class="Label">Bill To :</label>
                        </div>
                        <div class="col-md-4 px-1">
                            <div class="btn-group btn-group-toggle" style="width: 100%;">
                                <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Site'" name='billto'
                                        [disabled]="!BillToOption" [(ngModel)]="SiteBillTo">
                                    Site
                                </label>
                                <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Client'" name='billto'
                                        [disabled]="!BillToOption" [(ngModel)]="SiteBillTo">
                                    Client
                                </label>
                            </div>
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Ship To :</label>
                        </div>
                        <div class="col-md-3 px-1">
                            <div class="btn-group btn-group-toggle" style="width: 100%;">
                                <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Site'"
                                        [disabled]="!BillToOption" [(ngModel)]="SiteShipTo" name='shipto'>
                                    Site
                                </label>
                                <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Client'"
                                        [disabled]="!BillToOption" [(ngModel)]="SiteShipTo" name='shipto'>
                                    Client
                                </label>
                            </div>
                        </div>

                        <div class="col-md-5 px-1">
                            <div class="d-flex align-items-center mt-4">
                                <label class="Label">Auto Mail</label>
                                <input type="checkbox" class="form-check-input ms-2" id="checkbox"
                                    name="automailapplicable" [(ngModel)]="SiteAutoMail" />
                            </div>
                        </div>

                        <div class="col-md-5 px-1">
                            <div class="d-flex align-items-center mt-4">
                                <label class="Label">Place of supply</label>
                                <input type="checkbox" class="form-check-input ms-2" id="checkbox"
                                    name="SitePlaceOfSupplyApplicable" [(ngModel)]="SitePlaceOfSupplyApplicable" />
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row m-1"> -->

                    <!-- </div> -->

                    <div class="col-md-9 px-1">
                        <label class="Label">Default Narration</label>
                        <input name="defaultnarration" [(ngModel)]="SiteDefaultNarration" type="text"
                            class="form-control" placeholder="Narration" />
                    </div>
                    <hr>
                    <!-- <div class="row">
                        <div class="col-md-4 px-1">
                            <label class="Label" style="margin-left: 3%;">
                                Bill To Select
                                <input type="checkbox" name="billtooption" [(ngModel)]="BillToAllow"
                                    (change)="checkboxChange1()" ngbCheckbox />
                            </label>
                        </div>

                        <div class="col-md-1 px-1">
                            <label class="Label">Bill To :</label>
                        </div>
                        <div class="col-md-3 px-1">
                            <div class="btn-group btn-group-toggle" style="width: 100%;">
                                <label class="form-check-label Label" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Site'" name='billto'
                                        [disabled]="!BillToAllow" [(ngModel)]="SiteBillTo">
                                    Site
                                </label>
                                <label class="form-check-label Label" style="margin-left: 4%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Client'" name='billto'
                                        [disabled]="!BillToAllow" [(ngModel)]="SiteBillTo">
                                    Client
                                </label>
                            </div>
                        </div>
                    </div> -->

                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">ManPower Cost</label>
                            <input name="manpowercst" [(ngModel)]="ManpowerCost" type="text" style="text-align: right;"
                                class="form-control" placeholder="Enter Manpower Cost"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">ManPower</label>
                            <ng-select name="manpower" [(ngModel)]="ManPowerValue" placeholder="Select Manpower">
                                <ng-option value="Yes">Yes</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label"></label>
                            <ng-select name="manpoweratactual" [(ngModel)]="ManPowerValueAtactual">
                                <ng-option value="Actual">Actual</ng-option>
                                <ng-option value="Fixed">Fixed</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Machinery Cost</label>
                            <input name="machinerycost" [(ngModel)]="MachineryCost" type="text" class="form-control"
                                style="text-align: right;" placeholder="Enter Machinery Cost"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Machinery</label>
                            <ng-select name="machineryoptvalue" [(ngModel)]="MachineryOption"
                                placeholder="Select Machinery">
                                <ng-option value="Yes">Yes</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label"></label>
                            <ng-select name="machineryvalue" [(ngModel)]="MachineryValue">
                                <ng-option value="Actual">Actual</ng-option>
                                <ng-option value="Fixed">Fixed</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Consumables Cost</label>
                            <input name="Consumablescost" [(ngModel)]="ConsumableCost" type="text" class="form-control"
                                style="text-align: right;" placeholder="Enter Consumables Cost"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Consumables/Material</label>
                            <ng-select name="consumable" [(ngModel)]="consumoptvalue"
                                placeholder="Select Consumables/Material">
                                <ng-option value="Yes">Yes</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label"></label>
                            <ng-select name="consumableval" [(ngModel)]="consumablevalue">
                                <ng-option value="Actual">Actual</ng-option>
                                <ng-option value="Fixed">Fixed</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Mgmt Fees</label>
                            <input name="mgmtfees" [(ngModel)]="ManagementFees" type="text" class="form-control"
                                style="text-align: right;" placeholder="Enter Mgmt Fees"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Mgmt Fees(%)</label>
                            <input name="mgmtfeesvalue" [(ngModel)]="MgmtFeesValue" type="text" class="form-control"
                                style="text-align: right;" placeholder="Enter Mgmt Fees(%)" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Uniform</label>
                            <ng-select name="uniform" [(ngModel)]="uniformvalue" placeholder="Select Uniform">
                                <ng-option value="Yes">Yes</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">New/Lateral Site</label>
                            <br>
                            <div class="btn-group btn-group-toggle" style="width: 100%;">
                                <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'New'" name='sitetype'
                                        [(ngModel)]="SiteTypeValue">
                                    New Site
                                </label>
                                <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]="'Lateral'" name='sitetype'
                                        [(ngModel)]="SiteTypeValue">
                                    Lateral
                                </label>
                            </div>
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Other Charges</label>
                            <ng-select name="othercharges" [(ngModel)]="OtherChargesvalue"
                                placeholder="Select Other Charges">
                                <ng-option value="Yes">Yes</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label"></label>
                            <input name="otherval" [(ngModel)]="OtherValue" type="text" class="form-control"
                                style="text-align: right;" (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                    </div>



                    <hr>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Site Start Date<span class="text-danger">*</span></label>
                            <div class="input-group">
                                <input class="form-control" name="dateFieldStart" placeholder="Ex. DD MM YYYY"
                                    [(ngModel)]="siteactive" ngbDatepicker #d3="ngbDatepicker"
                                    [minDate]="{ year: 1930, month: 1, day: 1 }"
                                    [maxDate]="{ year: 2124, month: 12, day: 31 }" required readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()"
                                    type="button"></button>
                            </div>
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Site End Date <span class="text-danger">*</span></label>
                            <div class="input-group">
                                <input class="form-control" name="dateFieldEnd" placeholder="Ex. DD MM YYYY"
                                    [(ngModel)]="sitend" ngbDatepicker #d4="ngbDatepicker"
                                    [minDate]="{ year: 1930, month: 1, day: 1 }"
                                    [maxDate]="{ year: 2124, month: 12, day: 31 }" required readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d4.toggle()"
                                    type="button"></button>
                            </div>
                        </div>
                    </div>

                    <div class="card-header">
                        Bank Details
                    </div>

                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label">{{BranchName}}</label>
                            </div>
                            <div class="row">
                                <label class="Label">#{{SiteCode}}</label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>
                            <button class="btn btn-sm btn-primary" name="btn3" (click)="goToNextTab('Tab3')">
                                <i class="bi bi-arrow-right" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save & Next':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="4">
        <button ngbNavLink><i class="bi bi-cloud-haze2-fill"></i></button>
        <span class="stepper-text">Addition Details 2</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card-header">
                    Additional Clauses
                </div>
                <div class="card-body">
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label>Additional Clauses :</label>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">RBI Index</label>
                            <input type="checkbox" style="margin-left: 4%;" [(ngModel)]="RBIIndex" name="rbiindex"
                                ngbCheckbox />
                        </div>
                        <div class="col px-1">
                            <label class="Label">Minimum Wages DA Revision</label>
                            <input type="checkbox" [(ngModel)]="MinWages" style="margin-left: 4%;" name="minimumwages"
                                ngbCheckbox />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">

                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">% Income Growth</label>
                            <input type="checkbox" [(ngModel)]="PerIncGrowth" style="margin-left: 4%;"
                                name="incomgrowth" ngbCheckbox />
                        </div>
                        <div class="col px-1">
                            <label class="Label">Gaurd Board Index</label>
                            <input type="checkbox" [(ngModel)]="GuardBoardIndex" style="margin-left: 4%;"
                                name="gaurdboard" ngbCheckbox />
                        </div>
                    </div>
                    <hr>
                    <div class="row m-1">
                        <div class="col-md-6 px-1">
                            <label class="Label">New Industry Segment</label>
                            <input name="newindustryseg" [(ngModel)]="NewIndustrySegment" type="text"
                                class="form-control" placeholder="Enter New Industry Segment" />
                        </div>
                        <div class="col-md-6 px-1">
                            <label class="Label">Sub Sevice Type</label>
                            <input name="subservicetype" [(ngModel)]="SubServiceType" type="text" class="form-control"
                                placeholder="Enter Sub Sevice Type" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">New Sub Location1</label>
                            <input name="nesubloc1" [(ngModel)]="NewSubLocation1" type="text" class="form-control"
                                placeholder="Enter New Sub Location1" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">New Sub Location2</label>
                            <input name="nesubloc2" [(ngModel)]="NewSubLocation2" type="text" class="form-control"
                                placeholder="Enter New Sub Location2" />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Operation Team EmailID</label>
                            <input name="Operationteamemailid" [(ngModel)]="OperationTeamEmailId" type="email"
                                class="form-control" maxlength="500" placeholder="Enter Operation Team EmailID" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-6 px-1">
                            <label class="Label">Nature Of Work</label>
                            <input name="natureofwork" type="text" [(ngModel)]="CompNatureofWork" class="form-control"
                                placeholder="Enter Nature Of Work" />
                        </div>

                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Area(Sqft.)</label>
                            <input name="areasqft" type="text" class="form-control" [(ngModel)]="AreaSqFt"
                                style="text-align: right;" placeholder="Enter Area(Sqft.)"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>


                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Material Charges</label>
                            <ng-select name="uniform" [(ngModel)]="MatChargvalue"
                                (change)="onSelectChange('MaterialCharge')" placeholder="Select Material Charges">
                                <ng-option value="FV">Fixed Value</ng-option>
                                <ng-option value="Rsq">Rate / Sq. Ft.</ng-option>
                                <ng-option value="Per">Percentage</ng-option>
                                <ng-option value="Atc">At Actual</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label"></label>
                            <input name="MaterialChgVal" type="text" class="form-control" [(ngModel)]="MaterialChgVal"
                                style="text-align: right;" (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>

                    </div>
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Machinery Charges</label>
                            <ng-select name="machinerycharge" [(ngModel)]="machinerycharge"
                                (change)="onSelectChange('MachineryCharge')" placeholder="Select Machinery Charges">
                                <ng-option value="fix">Fixed Value</ng-option>
                                <ng-option value="prcnt">Percentage</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label"></label>
                            <input name="machineryvalue" [(ngModel)]="MachineryChgVal" type="text" class="form-control"
                                style="text-align: right;" (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>

                    </div>
                    <div class="row m-1">
                        <div class="col-md-5 px-1">
                            <label class="Label">PPU Machinery Cost</label>
                            <input name="pumachinarycost" placeholder="PPU Machinery Cost" type="text"
                                class="form-control" [(ngModel)]="PPUMachineryCost"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">PPU BG Cost</label>
                            <input name="ppubgcost" placeholder="PPU BG Cost" type="text" class="form-control"
                                [(ngModel)]="PPUBGCost" (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-5 px-1">
                            <label class="Label">PPU Business Provision%</label>
                            <input name="ppubusinessprov" placeholder="PPU Business Provision%" type="text"
                                class="form-control" [(ngModel)]="PPUBusinessProvisionPercent"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">PPU Business Prov. Value</label>
                            <input name="ppubusinessvalue" placeholder="PPU Business Prov. Value" type="text"
                                class="form-control" [(ngModel)]="PPUBusinessProvisionValue"
                                (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-5 px-1">
                            <label class="Label">CIS Margin%</label>
                            <input name="cismargin" placeholder="CIS Margin%" type="text" class="form-control"
                                [(ngModel)]="CISMarginValue" (keypress)="ValidateInput($event, 'allowtwodigit')" />
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">Site Count</label>
                            <input name="sitecount" placeholder="Site Count" type="text" class="form-control"
                                [(ngModel)]="Sitecount" (keypress)="ValidateInput($event, 'allowNumber')" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Manpower Strength</label>
                            <input name="manpowerstrength" placeholder="Manpower Strength" type="text"
                                class="form-control" [(ngModel)]="ManpowerStrength"
                                (keypress)="ValidateInput($event, 'allowNumber')" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-5 px-1">
                            <label class="Label">Attendance Date</label>
                            <input name="attendancedate" placeholder="Attendance Date" [maxlength]="2" type="text"
                                class="form-control" [(ngModel)]="AttendanceDateValue"
                                (keypress)="ValidateInput($event, 'allowNumber')" />
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">Salary Date</label>
                            <input name="salarydate" placeholder="Salary Date" [maxlength]="2" type="text"
                                class="form-control" [(ngModel)]="SalaryDateValue"
                                (keypress)="ValidateInput($event, 'allowNumber')" />
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-5 px-1">
                            <label class="Label">Salary Pay Date</label>
                            <input name="salarypaydate" placeholder="Salary Pay Date" [maxlength]="2" type="text"
                                class="form-control" [(ngModel)]="SalaryPaymentDateValue"
                                (keypress)="ValidateInput($event, 'allowNumber')" />
                        </div>
                        <div class="col-md-5 px-1">
                            <label class="Label">Billing Date</label>
                            <input name="billingdate" placeholder="Billing Date" [maxlength]="2" type="text"
                                class="form-control" [(ngModel)]="BillingDateValue"
                                (keypress)="ValidateInput($event, 'allowNumber')" />
                        </div>
                    </div>

                    <hr>
                    <div class="row m-1">

                        <div class="col-auto mt-2 px-1">
                            <input (change)="internalPocApplicableChange()" class="form-check-input" name="active" id="Active" type="checkbox"
                                [(ngModel)]="IsInternalPOCApplicable" value="" />&nbsp;&nbsp;
                            <label class="text-label-dark" for="checkbox">
                                Is Internal POC Applicable</label>
                        </div>

                        <div class="mb-2"></div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Internal POC Name</label>
                            <input [disabled]="!IsInternalPOCApplicable" name="InternalPOCName" type="text"
                                class="form-control" [(ngModel)]="InternalPOCName" placeholder="Internal POC name" />
                        </div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Internal POC Mobile No</label>
                            <input [disabled]="!IsInternalPOCApplicable" name="InternalPOCMobileNo" type="text"
                                class="form-control" [(ngModel)]="InternalPOCMobileNo"
                                (keypress)="ValidateInput($event, 'allowNumber')"
                                placeholder="Internal POC mobile number" />
                        </div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Internal POC Mail Id</label>
                            <input [disabled]="!IsInternalPOCApplicable" name="InternalPOCMailId" type="text"
                                class="form-control" [(ngModel)]="InternalPOCMailId" placeholder="InternalPOCMailId" />
                        </div>
                    </div>

                    <div class="row m-1">

                        <div class="col-auto mt-2 px-1">
                            <input (change)="clientPocApplicableChange()" class="form-check-input"
                                name="IsClientPOCApplicable" id="IsClientPOCApplicable" type="checkbox"
                                [(ngModel)]="IsClientPOCApplicable" value="" />&nbsp;&nbsp;
                            <label class="text-label-dark" for="checkbox">
                                Is Client POC Applicable</label>
                        </div>

                        <div class="col-auto mt-2 ms-3 px-1">
                            <input (change)="clientOnlyInformationChange()" class="form-check-input" name="IsClientOnlyInformation" id="IsClientOnlyInformation" type="checkbox"
                                [(ngModel)]="IsClientAttendanceInformationMail" value="" />&nbsp;&nbsp;
                            <label class="text-label-dark" for="checkbox">
                               Client Information Mail</label>
                        </div>

                        <div class="mb-2"></div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Client POC Name</label>
                            <input [disabled]="!IsClientPOCApplicable && !IsClientAttendanceInformationMail" name="ClientPOCName" type="text"
                                class="form-control" [(ngModel)]="ClientPOCName" placeholder="ClientPOCName" />
                        </div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Client POC Mobile No</label>
                            <input [disabled]="!IsClientPOCApplicable && !IsClientAttendanceInformationMail" name="ClientPOCMobileNo" type="text"
                                class="form-control" [(ngModel)]="ClientPOCMobileNo"
                                (keypress)="ValidateInput($event, 'allowNumber')" placeholder="ClientPOCMobileNo" />
                        </div>

                        <div class="col-md-4 px-1">
                            <label class="Label">Client POC Mail Id</label>
                            <input [disabled]="!IsClientPOCApplicable && !IsClientAttendanceInformationMail" name="ClientPOCMailId" type="text"
                                class="form-control" [(ngModel)]="ClientPOCMailId" placeholder="ClientPOCMailId" />
                        </div>

                        <hr style="margin-top: 20px">

                        <div class="row">
                            <div class="col-md-4 px-1">
                                <label class="Label">Attendance Through</label>
                                <ng-select [items]="AttendanceThroughLoad" bindLabel="AttendanceThrough"
                                    bindValue="AttendanceThrough" placeholder="Select Attendance through"
                                    [(ngModel)]="SiteAttendanceThrough" name="attendancethrough">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1">
                                <label class="Label">
                                    Gratuity
                                </label>
                                <ng-select [items]="GratuityLoad" bindLabel="Gratuity" bindValue="Gratuity"
                                    placeholder="Select Gratuity" [(ngModel)]="SiteGratuity" name="gratuity">
                                </ng-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 px-1">
                                <label class="Label">
                                    Leave Salary Cycle
                                </label>
                                <ng-select [items]="LeaveSalaryCycleLoad" bindLabel="LeaveSalarCycle"
                                    bindValue="LeaveSalarCycle" placeholder="Select leave salary cycle"
                                    [(ngModel)]="SiteLeaveSalarCycle" name="leavesalarycycle">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1">
                                <label class="Label">
                                    Leave Salary Payout
                                </label>
                                <ng-select [items]="LeaveSalaryPayoutLoad" bindLabel="LeaveSalary"
                                    bindValue="LeaveSalary" placeholder="Select leave salary"
                                    [(ngModel)]="SiteLeaveSalary" name="leavesalarypayout">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1"></div>

                            <div class="col-md-4 px-1">
                                <label class="Label">
                                    Bonus Cycle
                                </label>
                                <ng-select [items]="PayoutBonusesCycleLoad" bindLabel="PayoutBonusesCycle"
                                    bindValue="PayoutBonusesCycle" placeholder="Select bonus cycle"
                                    [(ngModel)]="SitePayoutBonusesCycle" name="bonuscycle">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1">
                                <label class="Label">
                                    Bonus Payout
                                </label>
                                <ng-select [items]="PayoutBonusLoad" bindLabel="PayoutBonus" bindValue="PayoutBonus"
                                    placeholder="Select bonus" [(ngModel)]="SitePayoutBonus" name="bonus">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1"></div>



                            <!-- <div class="col-md-4 px-1">
                            <label class="Label">
                                Gratuity
                            </label>
                            <ng-select [items]="GratuityLoad" bindLabel="Gratuity" bindValue="Gratuity"
                                placeholder="Select Gratuity" [(ngModel)]="SiteGratuity" name="gratuity">
                            </ng-select>
                        </div> -->

                            <div class="col-md-4 px-1">
                                <label class="Label">
                                    Uniforms
                                </label>
                                <ng-select [items]="UniformLoad" bindLabel="Uniforms" bindValue="Uniforms"
                                    placeholder="Select Uniforms" [(ngModel)]="SiteUniforms" name="uniform">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1">
                                <div class="d-flex align-items-center mt-4">
                                    <label class="Label">Uniform Deposit</label>
                                    <input type="checkbox" class="form-check-input ms-2" id="checkbox"
                                        name="isuniformdeposit" [(ngModel)]="SiteIsUniformsDeposit" />
                                </div>
                            </div>

                            <div class="col-md-4 px-1"></div>

                            <div class="col-md-4 px-1">
                                <label class="Label">Minimum Wage Industry</label>
                                <ng-select [items]="MinimumWageIndustryLoad" bindLabel="MinimumWageIndustry"
                                    bindValue="MinimumWageIndustry" placeholder="Select minimum wage industry"
                                    [(ngModel)]="SiteMinimumWageIndustry" name="minimumwageindustry">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1">
                                <label class="Label">Minimum Wage Zone</label>
                                <ng-select [items]="MinimumWageZoneLoad" bindLabel="MinimumWageZone"
                                    bindValue="MinimumWageZone" placeholder="Select minimum wage zone"
                                    [(ngModel)]="SiteMinimumWageZone" name="minimumwagezone">
                                </ng-select>
                            </div>

                            <div class="col-md-4 px-1">
                                <label class="Label">Wage structure</label>
                                <ng-select [items]="WageStrutureLoad" bindLabel="MinimumWageStructure"
                                    bindValue="MinimumWageStructure" placeholder="Select minimum wage structure"
                                    [(ngModel)]="SiteMinimumWageStructure" name="minimumwagestructure">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label">{{BranchName}}</label>
                            </div>
                            <div class="row">
                                <label class="Label">#{{SiteCode}}</label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>
                            <button class="btn btn-sm btn-primary" name="btn4" (click)="goToNextTab('Tab4')">
                                <i class="bi bi-arrow-right" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save & Next':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="5">
        <button ngbNavLink><i class="bi bi-people-fill"></i></button>
        <span class="stepper-text">Manpower</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card-header">
                    Site Manpower
                </div>
                <div class="card-body">
                    <div class="card">
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md-3 px-1">
                                    <label class="Label">Designation</label>
                                    <ng-select name="designation" [items]="DesignationLoad" [(ngModel)]="DesignationId"
                                        (change)="onSelectChange('Designation')" bindLabel="DesignationName"
                                        bindValue="DesignationMasterID"
                                        [disabled]="editMode || Sitedatafrmview.EditSData"
                                        placeholder="Select Designation">
                                        <ng-option *ngFor="let segment of DesignationLoad"
                                            [value]="segment.DesignationMasterID">
                                            {{ segment.DesignationName }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-3 px-1">
                                    <label class="Label">Duty</label>
                                    <ng-select name="dutyname" [items]="DutyLoad" [(ngModel)]="DutyId"
                                        (change)="onSelectChange('Duty')"
                                        [disabled]="editMode || Sitedatafrmview.EditSData" bindLabel="DutyName"
                                        bindValue="DutyMasterID" placeholder="Select Duty">
                                        <ng-option *ngFor="let segment of DutyLoad" [value]="segment.DutyMasterID">
                                            {{ segment.DutyName }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-3 px-1">
                                    <label class="Label">No Of Employee</label>
                                    <input name="employeofno" [(ngModel)]="noOfEmpValue" style="text-align: right;"
                                        type="text" class="form-control" placeholder="Enter No Of Employee"
                                        maxlength="10" (keypress)="PreventKey($event)"
                                        [disabled]="Sitedatafrmview.EditSData" />
                                </div>
                                <div class="col-md-3 px-1"><br>
                                    <button type="submit" style="width: 40%;" (click)="MapShift()"
                                        class="btn btn-primary text-nowrap">
                                        Shift</button>
                                </div>
                            </div>
                        </div>
                    </div><br>
                    <div class="row m-1">
                        <div class="col-md-6 px-1">
                            <div class="card">
                                <div class="card-header">
                                    Salary Calculation On
                                </div>
                                <div class="card-body">
                                    <div class="btn-group btn-group-toggle d-flex flex-column"
                                        (change)="onSelectionChange()" style="width: 100%;">
                                        <div class="row m-1">
                                            <div class="col-md-6 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'M'"
                                                        name='SalCalcOn' [(ngModel)]="SalaryCalcOn">
                                                    Total Month Days
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-6 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'W'"
                                                        name='SalCalcOn' [(ngModel)]="SalaryCalcOn">
                                                    Total Working Days
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-6 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'P'"
                                                        name='SalCalcOn' [(ngModel)]="SalaryCalcOn">
                                                    Per Day
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-4 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'F'"
                                                        name='SalCalcOn' [(ngModel)]="SalaryCalcOn">
                                                    Fix Days
                                                </label>
                                            </div>
                                            <div class="col-md-3 px-1">
                                                <input name="fixdays" type="text" [disabled]="SalaryCalcOn !== 'F'"
                                                    style="height: 70%; text-align: right;" class="form-control"
                                                    [(ngModel)]="salFixedDaysValue" (keypress)="onKeyPress($event)" />
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-4 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'S'"
                                                        name='SalCalcOn' [(ngModel)]="SalaryCalcOn">
                                                    Month Days
                                                </label>
                                            </div>
                                            <div class="col-md-3 px-1 position-relative">
                                                <span class="position-absolute"
                                                    style="left: -20px; top: 30%; transform: translateY(-50%); font-size: 18px;">
                                                    -
                                                </span>
                                                <input name="monthdays" type="text" [disabled]="SalaryCalcOn !== 'S'"
                                                    style="height: 70%; text-align: right;" class="form-control"
                                                    [(ngModel)]="SalmonthDayvalue" (keypress)="onKeyPress($event)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 px-1">
                            <div class="card">
                                <div class="card-header">
                                    Billing Calculation On
                                </div>
                                <div class="card-body">
                                    <div class="btn-group btn-group-toggle d-flex flex-column"
                                        (change)="onSelectionChange()" style="width: 100%;">
                                        <div class="row m-1">
                                            <div class="col-md-6 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'M'"
                                                        name='BilCalcOn' [(ngModel)]="BillCalOn">
                                                    Total Month Days
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-6 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'W'"
                                                        name='BilCalcOn' [(ngModel)]="BillCalOn">
                                                    Total Working Days
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-6 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'P'"
                                                        name='BilCalcOn' [(ngModel)]="BillCalOn">
                                                    Per Day
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-4 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'F'"
                                                        name='BilCalcOn' [(ngModel)]="BillCalOn">
                                                    Fix Days
                                                </label>
                                            </div>
                                            <div class="col-md-3 px-1">
                                                <input name="bilfixdays" type="text" [disabled]="BillCalOn !== 'F'"
                                                    style="height: 70%; text-align: right;" class="form-control"
                                                    [(ngModel)]="BllFixedDaysValue" (keypress)="onKeyPress($event)" />
                                            </div>
                                        </div>
                                        <div class="row m-1">
                                            <div class="col-md-4 px-1">
                                                <label class="form-check-label link-dark px-1 Label" ngbButtonLabel>
                                                    <input class="form-check-input" type="radio" [value]="'S'"
                                                        name='BilCalcOn' [(ngModel)]="BillCalOn">
                                                    Month Days
                                                </label>
                                            </div>
                                            <div class="col-md-3 px-1 position-relative">
                                                <span class="position-absolute"
                                                    style="left: -20px; top: 30%; transform: translateY(-50%); font-size: 18px;">
                                                    -
                                                </span>
                                                <input name="bilmonthdays" type="text" [disabled]="BillCalOn !== 'S'"
                                                    style="height: 70%; text-align: right;" class="form-control"
                                                    [(ngModel)]="BillmonthValue" (keypress)="onKeyPress($event)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row m-1">
                        <div class="col-md-6 px-1">
                            <label class="Label">Product Description</label>
                            <div class="md-form">
                                <textarea type="text" id="proddesp" name="proddesp"
                                    class="md-textarea md-textarea-auto form-control"
                                    placeholder="Enter Product Description" style="resize: none; height: 22px;"
                                    [(ngModel)]="ProductDesp" mdbInput></textarea>
                            </div>
                        </div>
                        <div class="col-md-3 px-1"><br>
                            <button class="btn btn-sm btn-primary" name="add" (click)="add()">
                                <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{ isDisabled ? 'Loading...' : (editMode ? 'Update' : 'Add') }}
                            </button>
                        </div>
                    </div>
                    <div class="card border-radius-0 mt-1 p-0">
                        <div class="card-body p-1" style="overflow: auto;">
                            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                class="customeDatatable table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col" style="display: none;">Designation ID</th>
                                        <th scope="col">Designation Name</th>
                                        <th scope="col" style="display: none;">Duty ID</th>
                                        <th scope="col">Duty Name</th>
                                        <th scope="col">No Of Employees</th>
                                        <th scope="col">Salary Calculation On</th>
                                        <th scope="col" style="display: none;">Salary Days Value</th>
                                        <th scope="col">Billing Calculation On</th>
                                        <th scope="col" style="display: none;">Billing Days Value</th>
                                        <th scope="col">Product Descripton</th>
                                        <th scope="col" style="display: none;">Table</th>
                                        <th scope="col">View</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let manPower of ManPowerTable; let i = index">
                                        <th scope="row">{{ i + 1 }}</th>
                                        <td style="display: none;">{{ manPower.designationid }}</td>
                                        <td>{{ manPower.designation }}</td>
                                        <td style="display: none;">{{manPower.dutyid}}</td>
                                        <td>{{manPower.duty}}</td>
                                        <td>{{ manPower.NoOfEmp }}</td>
                                        <td>{{ manPower.SalCalc }}</td>
                                        <td style="display: none;">{{manPower.saldaysValue}}</td>
                                        <td>{{ manPower.billcalc }}</td>
                                        <td style="display: none;">{{manPower.billDayvalue}}</td>
                                        <td>{{ manPower.prodDesp }}</td>
                                        <td style="display: none;">
                                            {{manPower.table}}
                                        </td>
                                        <td><button class="btn btn-sm btn-group-toggle btn-outline-primary"
                                                style="height: 50%; border: none;" (click)="ViewShift(manPower)">
                                                <i class="bi bi-eye"></i>
                                            </button>
                                        </td>
                                        <td>
                                            <button class="btn btn-sm btn-group-toggle"
                                                style="height: 50%; border: none;" (click)="onEditClick(manPower, i)">
                                                <i class="bi bi-pencil-square text-warning"></i>
                                            </button>

                                            &nbsp; <button class="btn btn-sm" name="delete" style="color: red;"
                                                (click)="deleteRow(i)" [disabled]="editMode"><i
                                                    class="bi bi-trash-fill"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card border-radius-0 mt-1 p-0" *ngIf="this.Sitedatafrmview.EditSData">
                        <div class="card-header">
                            As on Current Date ({{this.dateFormate.format(Date)}})
                        </div>
                        <div class="card-body p-1">
                            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                class="customeDatatable table table-bordered">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width: 5px;">#</th>
                                        <th>Branch Name</th>
                                        <th>Client Name</th>
                                        <th>Site Name</th>
                                        <th class="text-end" style="width: 30px;">No Of Person</th>
                                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                                            Summary</th>
                                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                                            Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let element of AllocationData; let i = index">
                                        <td style="width: 2px;">{{ i + 1 }}</td>
                                        <td>{{element['BranchName']}}</td>
                                        <td>{{element['ClientGroupName']}}</td>
                                        <td>{{element['SiteName']}}</td>
                                        <td class="text-end" style="width: 30px;">{{ element['NoOfPerson'] }}</td>

                                        <td style="width: 10px;" class="text-center"
                                            [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                                            <button type="button"
                                                class="btn btn-sm btn-outline-primary btn-custom-small"
                                                (click)="OpenDesignationSummary(element)">
                                                <i class="bi bi-file-text"></i>
                                            </button>
                                        </td>
                                        <td style="width: 10px;" class="text-center"
                                            [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                                            <button type="button" class="btn  btn-sm btn-outline-info btn-custom-small"
                                                (click)="DetailSum(element)">
                                                <i class="bi bi-info-circle"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label">{{BranchName}}</label>
                            </div>
                            <div class="row">
                                <label class="Label">#{{SiteCode}}</label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>
                            <button
                                *ngIf="(this.common.PageRight.IsAdd && this.Sitedatafrmview.SiteMasterId == '') || (this.common.PageRight.IsEdit && this.Sitedatafrmview.SiteMasterId != '')"
                                class="btn btn-sm btn-primary" name="btn5" (click)="save()" [disabled]="editMode">
                                <i class="bi bi-save" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>